import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type PartnerStatus,
  patchPartnersPartnerIDStatus,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "../Queries/queryKeys";

interface UpdatePartnerStatusParams {
  partnerID: string;
  status: PartnerStatus;
}

export function useUpdatePartnerStatusMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ partnerID, status }: UpdatePartnerStatusParams) =>
      patchPartnersPartnerIDStatus({ status }, partnerID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { partnerID }) => {
      queryClient.invalidateQueries({ queryKey: PARTNERS_QUERY_KEYS.all });
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.detail(partnerID),
      });
    },
  });
}
